<template>
    <b-sidebar backdrop :id="PopupUid" :title="$t('lbl_emp2_MembershipsBenefitsTitle')" right bg-variant="grey" backdrop
        :shadow="true">
        <div slot="title">
            <!-- <button class="btn btn-primary btn-lg" style="width: auto;" type="button"
                @click="addToCart(3); closecustomizer()">
                <i class="fa fa-plus-circle"></i>
                <span>加入購物車</span>
            </button> -->
            <a class="btn btn-danger" target="_blank" :href="JoinMemberUrl"
                t_label="link_empbe_SupplierMembershipsBenefits_JoinMember">
                {{ $t("lbl_emp2_JoinMemberPageButton") }}
            </a>

        </div>
        <div class="tab-pane active">
            <MABContent></MABContent>
        </div>
    </b-sidebar>
</template>
    
<script>
import { mapState, mapGetters } from 'vuex';
import MABContent from '../pages/memberhshipsAndBenefits/content.vue'

export default {
    props: ["PopupUid"],
    components: {
        MABContent
    },
    data() {
        return {
            JoinMemberUrl: 'https://www.chinaplasonline.com/eMarketplace/JoinMember/' + localStorage.getItem("currentLang") + '/?regsource=EMPBE_MembershipsAndBenefitsBtn'
        }
    },
    computed: {
        ...mapState({
            customizer: (state) => state.menu.customizer,
            layout: (state) => state.layout.layout,
            menuItems: state => state.menu.data,
            togglesidebar: (state) => state.menu.togglesidebar,
        }),
        ...mapGetters({
            getProductBySku: 'products/getProductBySku',
            getCartProductBySku: 'products/getCartProductBySku'
        })
    },
    methods: {
        //Add to cart
        addToCart: function (sku, qty) {
            var product = this.getCartProductBySku(sku);
            if (product != undefined) {
                this.$store.dispatch('products/updateCartQuantity', { 'product': product, 'qty': 1 });
            }
            else {
                product = this.getProductBySku(sku);
                product.quantity = qty ? qty : 1;
                this.$store.dispatch('products/addToCart', product);
            }
            this.cart_open();
        },
        cart_open() {
            this.$store.dispatch('products/toggleCart', true);
        },
        closecustomizer() {
            this.$parent.$refs["btn_visitorPermissionPopup"].click();
            this.$store.state.menu.customizer = '';
            this.$store.state.menu.customizerTitle = '';
        },
    },
};
</script>
